module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAyMCI+PHBhdGggZD0iTTEwIDIwYTEwIDEwIDAgMSAxIDAtMjAgMTAgMTAgMCAwIDEgMCAyMHptMC0yYTggOCAwIDEgMCAwLTE2IDggOCAwIDAgMCAwIDE2em0tMS03LjU5VjRoMnY1LjU5bDMuOTUgMy45NS0xLjQxIDEuNDFMOSAxMC40MXoiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/images/time.svg
// module id = 457
// module chunks = 35783957827783